import React from 'react';
import { motion } from 'framer-motion';
import { FaGithub, FaLinkedin, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import { Link } from 'react-scroll';
import profileImg from '../../assets/profile.png';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero" id="hero">


      <div className="container hero__content">
        <motion.div
          className="hero__text"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
        >
          <span className="hero__greeting">Hello, I'm</span>
          <h1 className="hero__name">
            Sudip <span className="hero__name-accent">Majkoti</span>
          </h1>
          <h2 className="hero__title">AI Engineer</h2>
          <p className="hero__desc">
            Building intelligent AI agents, RAG-based chatbots, and deep learning
            models. Passionate about conversational intelligence and end-to-end AI
            deployment.
          </p>

          <div className="hero__location">
            <FaMapMarkerAlt />
            <span>Bhaktapur, Nepal</span>
          </div>

          <div className="hero__actions">
            <Link to="projects" smooth duration={500} offset={-80} className="btn btn-primary">
              View My Work
            </Link>
            <Link to="contact" smooth duration={500} offset={-80} className="btn btn-outline">
              Get In Touch
            </Link>
          </div>

          <div className="hero__socials">
            <a href="https://github.com/sudipmajkoti07" target="_blank" rel="noreferrer" aria-label="GitHub">
              <FaGithub />
            </a>
            <a href="https://linkedin.com/in/sudipmajkoti" target="_blank" rel="noreferrer" aria-label="LinkedIn">
              <FaLinkedin />
            </a>
            <a href="mailto:sudipmazkoti@gmail.com" aria-label="Email">
              <FaEnvelope />
            </a>
          </div>
        </motion.div>

        <motion.div
          className="hero__visual"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.3, ease: 'easeOut' }}
        >
          <div className="hero__avatar">
            <div className="hero__avatar-inner">
              <img src={profileImg} alt="Sudip Majkoti" className="hero__avatar-img" />
            </div>
          </div>
        </motion.div>
      </div>

      <div className="hero__scroll-indicator">
        <Link to="about" smooth duration={500} offset={-80}>
          <div className="hero__scroll-mouse">
            <div className="hero__scroll-dot" />
          </div>
        </Link>
      </div>
    </section>
  );
};

export default Hero;
